import { IS_REQUIRED, PASSWORD_ERROR_MESSAGE, PASSWORD_MISMATCH } from 'common/constants/messages/validations';
import { userSchemaBase } from 'common/constants/userSchemaBase';

export const constraints = {
  ...userSchemaBase,
  password: {
    presence: { allowEmpty: false, message: IS_REQUIRED },
    length: {
      maximum: 128,
    },
    format: {
      pattern: /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_]).{9,}$/,
      message: `^${PASSWORD_ERROR_MESSAGE}`,
    },
  },
  re_password: {
    presence: { allowEmpty: false, message: IS_REQUIRED },
    length: {
      maximum: 128,
    },
    equality: {
      attribute: 'password',
      message: `^${PASSWORD_MISMATCH}`,
    },
  },
};
